import * as S from "../../Style/Page/Fork.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleFork.js";
import HatPageTopLine from "../../Component/ForkPageTopLine.js";

import Factory1 from "../../assets/fork/05. 미국본사 달라스.jpg";
import Factory2 from "../../assets/fork/06. 미국본사 렉싱턴.jpg";
import Factory3 from "../../assets/fork/07. 미국본사 루이빌.jpg";
import Factory4 from "../../assets/fork/사진 04.jpg";
import Lift from "../../assets/fork/08. 미국본사 지게차.png";
const HeadOfficeUsa = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"지게차사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/Introduce">
                <div className="kor">지게차사업</div>
                <div className="eng">ForkLift Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">ForkLift Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                <div className="kor">지역별법인</div>
                <div className="eng">Corporation by region</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">클라크</div>
                  <div className="eng">ForkLift Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                  <div className="kor">지역별법인</div>
                  <div className="eng">Corporation by region</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"624px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                <div className="kor">클라크 미국본사</div>
                <div className="eng">CLARK USA HQ</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                  <div className="kor">클라크 미국본사</div>
                  <div className="eng">CLARK USA HQ</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice2">
                  <div className="kor">브라질 법인</div>
                  <div className="eng">Brasil Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice3">
                  <div className="kor">코스타리카 법인</div>
                  <div className="eng">Costa-Rica Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice4">
                  <div className="kor">독일 법인</div>
                  <div className="eng">Germany Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice5">
                  <div className="kor">프랑스 법인</div>
                  <div className="eng">France Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice6">
                  <div className="kor">호주 법인</div>
                  <div className="eng">Australia Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice7">
                  <div className="kor">싱가폴 법인</div>
                  <div className="eng">Singapore Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice8">
                  <div className="kor">한국 법인 (부천)</div>
                  <div className="eng">Korea HQ (Bucheon)</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice9">
                  <div className="kor">베트남 1공장</div>
                  <div className="eng">Vietnam Company1</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice10">
                  <div className="kor">베트남 2공장</div>
                  <div className="eng">Vietnam Company2</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice11">
                  <div className="kor">중국법인</div>
                  <div className="eng">China Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice12">
                  <div className="kor">한국 법인 (창원)</div>
                  <div className="eng">Korea Company (Changwon) </div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"클라크 미국본사"}
              titleeng={"CLARK USA HQ"}
              link={"http://www.clarkmhc.com/"}
            />
            <div className="page-text">
              CLARK Material Handling Company / CMHC
            </div>

            <S.ImgHolderFlex>
              <S.ImgHolderHarf>
                <img src={Factory1} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">클라크 미국 본사 (달라스)</div>
                  <div className="eng">CLARK USA HQ (Dallas)</div>
                </div>
              </S.ImgHolderHarf>

              <S.ImgHolderHarf>
                <img src={Factory4} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">공장내부</div>
                  <div className="eng">Factory Interior</div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex>

            <S.ImgHolderFlex>
              <S.ImgHolderHarf>
                <img src={Factory2} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">렉싱턴 (공장 / 연구소)</div>
                  <div className="eng">Lexington (Factory/R&D)</div>
                </div>
              </S.ImgHolderHarf>

              <S.ImgHolderHarf>
                <img src={Factory3} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">루이빌 (창고)</div>
                  <div className="eng">
                    Louisville <br />
                    (A/S parts distribution center)
                  </div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex>
            <PageTitle titleko={"주요 이력"} titleeng={"Major History"} />
            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor">
                      CLARK Material Handling Company 법인개요
                    </div>
                    <div className="eng">
                      Company Profile of CLARK Material Handling Company
                    </div>
                  </div>
                  <div className="kor">
                    클라크 설립: 1903년 <br />
                    클라크 트럭트랙터 컴퍼니 설립 (현 CMHC 모체회사) : 1919년
                    <br />
                    영안모자 인수 : 2003년 1월
                    <br />
                    클라크 글로벌 본사 미국으로 재이전 : 2022년 4월 / 공식 가동
                    : 2025년 1월
                  </div>
                  <div className="eng">
                    Establishment : 1903 <br />
                    Established CLARK tractructer company <br />
                    (Mother company of CMHC) : 1919 <br />
                    YA acquired : Jan., 2003 <br />
                    Returned CLARK Global HQ to U.S.A. : 2022. Apr. / official
                    operating : 2025. Jan.
                  </div>
                </div>
              </div>
              <div className="kor">
                ※ 클라크 지게차의 모체회사이며 전세계 클라크 라이선스 소유회사
                <br />
                ※ 1917년 세계 최초로 엔진식 산업용 지게차 개발 / 지게차의 효시
                <br />
                ※ 지게차본사/ 글로벌본부 역할 수행
                <br />
                ※ 미국 내 텍사스주 달라스 (본사) 및 켄터키주 렉싱턴 (공장,
                연구소), 켄터키주 루이빌 (부품창고) 운영중
                <br />
                ※ 판매지역 : 북미 (미국 + 캐나다 + 멕시코)
                <br />
                ※ CMHI는 클라크 지주회사 및 아시아 본부 업무 역할 수행
                <br />※ 생산법인 관리 및 글로벌 지원 역할 진행
              </div>
              <div className="eng">
                ※ Parent company of CLARK forklifts and owns CLARK licenses
                around the world <br />
                ※ Development of the world's first engine-powered industrial
                forklift in 1917 <br />
                &nbsp;&nbsp;&nbsp;&nbsp;/ The beginning of the forklift <br />
                ※ Operate as CLARK Headoffice / CLARK Global HQ <br />
                ※ Operate in Dallas for HQ, Lexington for Factory & R&D and
                Louisville for warehouse <br />
                ※ Sales territory : North America ( U.S.A. + CANADA + MEXICO){" "}
                <br />
              </div>
              <img src={Lift} alt="" className="hat-img" />
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default HeadOfficeUsa;
